import { useState, useEffect } from 'react';

import { useNetworkState, usePrev } from '@services/hooks.service';

function ImageWithFallback({
  src,
  fallbackSrc,
  alt = '',
  className = '',
  ...props
}) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  
  const isOnline = useNetworkState();
  const prevIsOnline = usePrev(isOnline);

  useEffect(() => {
    setImgSrc(src);
    setHasError(false);
  }, [src]);

  useEffect(() => {
    if (isOnline && !prevIsOnline && hasError) {
      setHasError(false);
      setImgSrc(src);
    }
  }, [isOnline, prevIsOnline, hasError, src]);

  function handleError() {
    if (!hasError) {
      setHasError(true);
      setImgSrc(fallbackSrc);
    }
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
}

export default ImageWithFallback;